function NotFound() {
    return(
        <div className="d-flex justify-content-center align-items-center row-item">
            <p className="fs-2 fw-bold text-danger">Sorry! this page not found.</p>
        </div>
    );
}

export default NotFound;